import { resources } from "@constants/hardcoded-strings";
import { formatServiceTemplateDetails } from "@formatters/service-template-details/service-template-details-formatter";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { FormattedServiceTemplateDetails, ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { setServiceTemplateDetails } from "@redux/actions/service-template-details-actions";
import { updateServiceTemplateRequest } from "@requests/management-console/update-service-template";
import {
    displaySuccessModal,
    logAndDisplayErrorModal
} from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const updateServiceTemplateReduxRequest = (dispatch: Dispatch) => async (
    serviceTemplate: ServiceTemplateDetails,
    axnCompanies: Array<AxnCompany>
): Promise<FormattedServiceTemplateDetails> => {
    const { data, error, body } = await updateServiceTemplateRequest(serviceTemplate);
    if (data?.transferObject) {
        const formattedServiceDetails = formatServiceTemplateDetails(data.transferObject, axnCompanies);

        dispatch(setServiceTemplateDetails(formattedServiceDetails));
        displaySuccessModal(
            dispatch,
            resources.requests.updateServiceTemplate.success.title,
            resources.requests.updateServiceTemplate.success.message
        );
        return formattedServiceDetails;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateServiceTemplate.error.title,
            resources.requests.updateServiceTemplate.error.message,
            error,
            null,
            body
        );
    }

    return null;
};